<template>
  <b-card title="เพิ่มรายการจองคิว">
    <b-row>
      <b-col md="6">
        <b-form-group label-for="lastname">
          <h5 class="font-weight-bold">เลขรหัสนายหน้า</h5>
          <b-form-input v-model="formUser.agentId" placeholder="เลขรหัสนายหน้า" :class="{ 'is-invalid': showError }" />
          <div class="invalid-feedback">กรุณาระบุเลขรหัสนายหน้า</div>
        </b-form-group>
      </b-col>
      <b-col md="6"></b-col>
      <b-col md="6">
        <div class="demo-inline-spacing">
          <span class="h4 font-weight-bold">ประเภท</span>
          <b-form-radio v-model="selected" name="some-radio9" value="MOU" class="custom-control-danger">
            MOU
          </b-form-radio>
          <b-form-radio v-model="selected" name="some-radio9" value="NL" class="custom-control-warning">
            NL
          </b-form-radio>
          <b-form-radio v-model="selected" name="some-radio9" value="IW" class="custom-control-info">
            IW
          </b-form-radio>
        </div>
        <span class="text-muted" style="color: red;">* กรณี ไม่มี alcode ระบบจะ IW อัตโนมัติ</span>
        <br></br>
      </b-col>
      <b-col md="6">

      </b-col>
      <b-col md="6">
        <b-form-group>
          <h5 class="h4 font-weight-bold">เลือกศูนย์แรงงานต่างด้าว</h5>
          <b-form-select v-model="selectedBorder" :options="options" @change="GetChange" />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-card-text class="h4 mt-1 mb-0 font-weight-bold mb-2" v-if="selectedBorder && count_data != 0">
          <template v-if="out_dateDefault">
            <span class="text-primary">
              คิวที่เหลือ:
              <strong>
                / ศูนย์ {{ selectedBorder }} / {{ count_data }}
              </strong>
              คิว
            </span>
          </template>
          <template v-else>
            <span class="text-danger">กรุณาเลือกวันที่</span>
          </template>
        </b-card-text>
      </b-col>
      <b-col md="6">
        <b-form-group>
          <h5 class="h4 font-weight-bold">วันที</h5>
          <flat-pickr v-model="out_dateDefault" class="form-control" :config="outDateConfig" />
          <div class="invalid-feedback">วันที</div>
        </b-form-group>
      </b-col>
      <!-- <b-col md="6">
        <b-form-group>
          <h5 class="font-weight-bold">ด่านชายแดน</h5>
          <b-form-select v-model="selectedBorder" :options="options" />
          <div class="invalid-feedback">กรุณาเลือกด่านชายแดน</div>
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-card-text class="mt-1 mb-0 font-weight-bold mb-2" v-if="selectedBorder && count_data != 0">
          <template v-if="out_dateDefault">
            <span class="text-primary">
              คิวที่เหลือ:
              <strong>
                / ด่านชายแดน จังหวัด{{ selectedBorder }} / {{ count_data }}
              </strong>
              คิว
            </span>
          </template>

          <template v-else>
            <span class="text-danger">กรุณาเลือกวันที่</span>
          </template>
        </b-card-text>
      </b-col>

      <b-col md="6">
        <br />
        <b-form-group>
          <h5 class="font-weight-bold">วันที่เดินทางออกประเทศไทย</h5>
          <flat-pickr v-model="out_dateDefault" class="form-control" :config="outDateConfig" />
          <div class="invalid-feedback">วันที่เดินทางออกประเทศไทย</div>
        </b-form-group>
      </b-col>
      <div class="demo-inline-spacing">
        <h5 class="font-weight-bold">เลือกรอบ</h5>
        <b-form-radio v-model="selected" name="some-radio9" value="รอบเช้า" class="custom-control-primary">
          รอบเช้า
        </b-form-radio>
        <b-form-radio v-model="selected" name="some-radio9" value="รอบบ่าย" class="custom-control-success">
          รอบบ่าย
        </b-form-radio>
      </div>
      <b-col md="6">
        <b-form-group>
          <h5 class="font-weight-bold">วันที่เข้าประเทศไทย</h5>
          <flat-pickr v-model="in_dateDefault" class="form-control" :config="{ dateFormat: 'd-m-Y' }" />
          <div class="invalid-feedback">วันที่เข้าประเทศไทย</div>
        </b-form-group>
      </b-col> -->

      <!-- <b-card-text class="mt-1 mb-0">
      Selected: <strong>{{ selected }}</strong>
    </b-card-text> -->
    </b-row>
</br>
    <b-col cols="12">
      <b-button variant="success" type="submit" @click.prevent="validationForm" :disabled="isLoading">
        <template v-if="isLoading">
          <b-spinner small type="grow" class="mr-1" />
          กำลังบันทึก...
        </template>
        <template v-else>
          บันทึกข้อมูล
        </template>
      </b-button>
    </b-col>
</br>
    <h4 class="text-primary font-weight-bold mb-2" v-if="items && items.length > 0">
      ข้อมูลแรงานต่างด้าว : {{ items.length }} รายการ
    </h4>

    <b-col cols="12">
      <b-table striped hover responsive :per-page="perPage" :current-page="currentPage" :items="items" :fields="fields"
        :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" :filter="filter"
        :filter-included-fields="filterOn" @filtered="onFiltered">
      </b-table>
    </b-col>
  </b-card>
</template>

<script>
// ===== Vue & 3rd-party Plugins =====
import Ripple from "vue-ripple-directive";
import axios from "axios";

// ===== Project Modules =====
import store from "@/store/index";
import API from "@/connect/config";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";

import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { BSpinner, BButton } from 'bootstrap-vue'
import QRCode from "qrcode";

import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);

export default {
  components: {
    flatPickr,
    BButton,
    BSpinner,
  },
  directives: {
    Ripple,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      perPage: 100,
      pageOptions: [25, 50, 100],
      totalRows: 1,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      fields: [
        { key: "No.", label: "ลำดับที่" },
        { key: "employerNumber", label: "เลขประจำตัวนายจ้าง" },
        { key: "alcode", label: "เลขพาสปอร์ต/เลขที่ประจำตัว13หลัก" },
        { key: "Prefix", label: "คำนำหน้า" },
        { key: "firstname", label: "ชื่อ" },
        { key: "lastname", label: "นามสกุล" },
        { key: "Sex", label: "เพศ" },
        // { key: "DateofBirth", label: "วันเดือนปีเกิด" },
      ],
      items: [],
      selected: "MOU", // ✅ "รอบเช้า" ถูกเลือกโดยอัตโนมัติ
      selectedBorder: null, // ✅ ค่า default (ตรงกับ value: null)
      outDateConfig: {
        dateFormat: "d-m-Y",
        onChange: this.handleOutDateChange.bind(this),
      },
      options: [{ value: '', text: "เลือกศูนย์" }],
      formUser: {
        username: "",
        password: "",
        passwordFieldType: "password",
        firstname: "",
        lastname: "",
        agentId: "",
      },
      in_dateDefault: null, //new Date(), // หรือใช้ null, หรือ new Date() ก็ได้
      out_dateDefault: new Date(), // new Date(), // หรือใช้ null, หรือ new Date() ก็ได้
      count_data: 0,
      showError: false,
      isLoading: false,

    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },
  },
  created() {
    //  console.log(localStorage.getItem("data_addqueue"));
  },
  mounted() {
    this.getDataSelectOption();

    this.outDateConfig.onChange = this.handleOutDateChange;
    this.totalRows = this.items.length;
    this.getData();
  },
  watch: {
    selectedBorder(newVal) {
      if (newVal) {
        this.count_data = 0; // หากเลือกด่านชายแดน ให้รีเซตเป็น 0
      }

    },
    'items.alcode'(newVal) {
      if (newVal === "") {
        this.selected = "IW"; // ถ้า alcode ว่าง → auto เลือก IW
      }
    }
  },
  methods: {
    async getData() {
      const dd = await store.getters.getChang;
      //   const dd = await this.$store.dispatch("data_addqueue");
      console.log(dd);
      this.items = dd[0];
      console.log(this.items);
      if (this.items != undefined) {

        if (this.items[0].alcode === "") {
          this.selected = "IW";
        }
      } else {
        this.items = [];
        this.$router.push({ name: "namelist" });

      }

    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    formatToYYYYMMDD(dateInput) {
      let parsedDate;

      // 1. ถ้า dateInput เป็น Date object หรือ ISO string
      if (dateInput instanceof Date || /\d{4}-\d{2}-\d{2}T/.test(dateInput)) {
        parsedDate = dayjs(dateInput);
      } else if (/^\d{2}-\d{2}-\d{4}$/.test(dateInput)) {
        // 2. ถ้าเป็น string รูปแบบ DD-MM-YYYY หรือ MM-DD-YYYY
        // เราจะพยายาม parse แบบ DD-MM-YYYY ก่อน
        parsedDate = dayjs(dateInput, "DD-MM-YYYY", true);
        if (!parsedDate.isValid()) {
          parsedDate = dayjs(dateInput, "MM-DD-YYYY", true);
        }
      } else {
        // กรณีอื่น ๆ
        parsedDate = dayjs(dateInput);
      }

      if (!parsedDate.isValid()) {
        console.error("วันที่ไม่ถูกต้อง:", dateInput);
        return null;
      }

      return parsedDate.format("YYYYMMDD");
    },
    async GetChange() {
      // const today = new Date();
      // const day = String(today.getDate()).padStart(2, '0');
      // const month = String(today.getMonth() + 1).padStart(2, '0'); // เดือนเริ่มจาก 0
      // const year = today.getFullYear();

      //this.handleOutDateChange('', `${day}-${month}-${year}`);
      this.handleOutDateChange(this.out_dateDefault, this.formatToYYYYMMDD(this.out_dateDefault).replace(/(\d{4})(\d{2})(\d{2})/, '$3-$2-$1'));
    },
    // async handleOutDateChange(selectedDates, dateStr) {

    //   console.log("📅 วันที่ออกถูกเลือก:", dateStr.split("-"));
    //   console.log("ด่านชายแดน:", this.selectedBorder);
    //   // ถ้ามีวันที่เลือก ให้ set 500
    //   //if (selectedDates && selectedDates.length > 0) {
    //   if (this.selectedBorder == null) {
    //     console.log("Selected Border:", this.selectedBorder);

    //     return;
    //   }

    //   const [dayExit, monthExit, yearExit] = dateStr.split("-");
    //   try {
    //     const jwt = JSON.parse(localStorage.getItem("company_jwt"));
    //     const params = {
    //       staffId: jwt.userId,
    //       date: `${yearExit}${monthExit}${dayExit}`,
    //     };
    //     console.log("Request Params", params);
    //     const res = await axios.get(`${API}queueStatus`, {
    //       params,
    //       headers: {
    //         Authorization: await store.dispatch("getAuthorization"),
    //       },
    //     });
    //     const stationData = res.data.message.stations.find(
    //       (station) => station.stationName === this.selectedBorder
    //     );

    //     this.count_data = stationData.remaining; // รีเซ็ตค่า count_data ก่อนคำนวณใหม่

    //     console.log("API Response", stationData)
    //     return res.data.message.data;
    //   } catch (err) {
    //     console.error("❌ Error:", err.response?.data || err.message);
    //   } finally {
    //     this.isBusy = false;
    //   }
    // },
    // async getDataSelectOption() {
    //   const jwt = JSON.parse(localStorage.getItem("company_jwt"));
    //   try {
    //     const res = await axios.get(`${API}config?userId=${jwt.userId}`,
    //       {
    //         headers: {
    //           Authorization: await store.dispatch("getAuthorization"),
    //         },
    //       });
    //     console.log("✅ success");
    //     const responseData = res.data.message.data;

    //     // แปลงข้อมูลให้ตรงกับรูปแบบ dropdown
    //     const dynamicOptions = responseData.map((item) => ({
    //       value: item.stationName, // สมมติ field ชื่อ borderName
    //       text: item.stationName,
    //     }));

    //     // รวม option แรก + ตัวเลือกจาก API
    //     this.options = [{ value: null, text: "-- เลือกศูนย์ --" }, ...dynamicOptions];
    //   } catch (err) {
    //     if (err.response) {
    //       console.error("❌ API Error:", err.response.status);
    //       console.error("Response:", err.response.data);
    //     } else {
    //       console.error("❌ Error:", err.message);
    //     }
    //   }
    // },
    async handleOutDateChange(selectedDates, dateStr) {
      console.log(dateStr);
      console.log("📅 วันที่ออกถูกเลือก:", dateStr.split("-"));
      console.log("ด่านชายแดน:", this.selectedBorder);
      // ถ้ามีวันที่เลือก ให้ set 500
      //if (selectedDates && selectedDates.length > 0) {
      if (this.selectedBorder == null) {
        console.log("Selected Border:", this.selectedBorder);
        return;
      }

      const [dayExit, monthExit, yearExit] = dateStr.split("-");
      try {
        const jwt = JSON.parse(localStorage.getItem("company_jwt"));
        const params = {
          staffId: jwt.userId,
          date: `${yearExit}${monthExit}${dayExit}`,
        };
        console.log("Request Params", params);
        const res = await axios.get(`${API}queueStatus`, {
          params,
          headers: {
            Authorization: await store.dispatch("getAuthorization"),
          },
        });
        console.log((res.data.message.centers));
        const stationData = res.data.message.centers.find(
          (station) => station.centerName === this.selectedBorder
        );
        console.log("stationData:", stationData);

        if (stationData) {
          this.count_data = stationData.remaining; // รีเซ็ตค่า count_data ก่อนคำนวณใหม่
        } else {
          console.warn("ไม่พบสถานีที่ตรงกับ:", this.selectedBorder);
          this.count_data = 0; // หรือค่า default อื่น ๆ
        }

        console.log("API Response", stationData);
        return res.data.message.data;
      } catch (err) {
        console.error("❌ Error:", err.response?.data || err.message);
      } finally {
        this.isBusy = false;
      }
    },

    async getDataSelectOption() {
      const jwt = JSON.parse(localStorage.getItem("company_jwt"));
      try {
        const params = {
          userId: jwt.userId,
          configType: "center",
        };
        console.log("API Request Params", params);
        const res = await axios.get(`${API}config`, {
          params,
          headers: {
            Authorization: await store.dispatch("getAuthorization"),
          },
        });

        const responseData = res.data.message.data;
        // แปลงข้อมูลให้ตรงกับ dropdown
        const dynamicOptions = responseData.map((item) => ({
          value: item.name,
          text: item.name,
        }));
        console.log(dynamicOptions);
        this.options = [{ value: '', text: "เลือกศูนย์" }, ...dynamicOptions];
        // ตั้งค่า default เป็นตัวแรก    
        this.selectedBorder = this.options[0].value;
      } catch (err) {
        if (err.response) {
          console.error("❌ API Error:", err.response.status);
          console.error("Response:", err.response.data);
        } else {
          console.error("❌ Error:", err.message);
        }
      }
    },
    async Postentry(userId, IdCode, employerName, employerNumber, employerPhone) {
      const jwt = JSON.parse(localStorage.getItem("company_jwt"));
      const [dayExit, monthExit, yearExit] = this.out_dateDefault.split("-");
      const [dayEntry, monthEntry, yearEntry] = this.in_dateDefault.split("-");

      const _data = {
        userId: userId,
        staffId: jwt.userId,
        shift: this.selected,
        IdCode: IdCode,
        registeredExitDate: `${yearExit}${monthExit}${dayExit}`,
        registeredEntryDate: `${yearEntry}${monthEntry}${dayEntry}`,
        stationName: this.selectedBorder,
        employerName: employerName,
        employerNumber: employerNumber,
        employerPhone: employerPhone,
        agentId: this.formUser.agentId
      };
      console.log(_data)

      try {
        const res = await axios.post(`${API}entry`, _data, {
          headers: {
            Authorization: await store.dispatch("getAuthorization"),
          }
        });
        console.log("✅ Entry success:", res.data.message);
      } catch (error) {
        console.error("❌ Entry error:", error.response);
      }
    },
    async Postentry_preRegister(userId, IdCode, employerName, employerNumber, employerPhone) {
      const jwt = JSON.parse(localStorage.getItem("company_jwt"));
      const [day, month, year] = this.out_dateDefault.split("-");
      const _status =
        [{ "ลงทะเบียน": "สำเร็จ" }]

      const _data = {
        userId: userId,
        staffId: jwt.userId,
        IdCode: IdCode,
        employerName: employerName,
        employerNumber: employerNumber,
        employerPhone: employerPhone,
        agentId: this.formUser.agentId,
        processingStatus: JSON.stringify(_status),
        centerName: this.selectedBorder,
        centerAt: `${year}${month}${day}`,

        //  WorkersCenter: this.selectedBorder,
        //  WorkersCenterDate: `${year}${month}${day}`,
        //  statusadmin: jwt.//คนที่บันทึกข้อมูล,
      };
      console.log(_data)

      try {
        const res = await axios.post(`${API}preRegister`, _data, {
          headers: {
            Authorization: await store.dispatch("getAuthorization"),
          }
        });
        console.log("✅ Entry success:", res.data.message);
      } catch (error) {
        console.error("❌ Entry error:", error.response.data.message);
        //console.error("❌ Entry error:", error.response);
      }
    },
    async validationForm() {

      let typeValue = ""

      if (this.selected === "MOU") typeValue = '1'
      if (this.selected === "NL") typeValue = '2'
      if (this.selected === "IW") typeValue = ""

      console.log("ค่าที่ได้:", typeValue)
      console.log("ประเภทที่เลือก:", this.selected)



      // if (!this.formUser.agentId) {
      //   this.showError = true;
      //   console.log("กรุณาระบุรหัสนายหน้า");
      //   return; // หยุด submit
      // } else {
      //   this.showError = false;
      // }


      this.isLoading = true;
      const jwt = JSON.parse(localStorage.getItem("company_jwt"));

      try {
        const promises = this.items.map(async (item) => {
          let IdCode = ""
          if (this.selected === "IW") {
            // กรณี IW → append แค่ IdCode อย่างเดียว
            // IdCode = item.IdCode;
          } else {
            // กรณีอื่น → append typeValue + IdCode
            IdCode = typeValue + item.alcode;
          }


          console.log(IdCode, item.employerName, item.employerNumber, item.employerPhone);
          console.log(IdCode, item.Prefix, item.firstname, item.lastname, item.Nationality)

          const _data = new FormData();
          _data.append("companyId", jwt.companyId);
          _data.append("username", IdCode);
          _data.append("password", "Password@1");
          _data.append("role", "user");
          _data.append("prefix", item.Prefix);
          _data.append("firstname", item.firstname);
          _data.append("lastname", item.lastname);
          _data.append("gender", item.Sex);
          _data.append("nationality", item.Nationality);
          _data.append("workAuthStatus", this.selected);

          //   _data.append("IdCode", item.IdCode);

          try {
            const res = await axios.post(`${API}registerUser`, _data, {
              headers: {
                Authorization: await store.dispatch("getAuthorization"),
              }
            });
            const res_userId = res.data.message.userId;
            console.log("✅ Registered:", res_userId);

            if (this.selected === "IW") {
              IdCode = res.data.message.IdCode; // กรณี IW ใช้ IdCode จาก response ตรง ๆ
            }
            // if (this.selectedBorder && this.out_dateDefault && this.in_dateDefault) {
            // await this.Postentry(res_userId, item.IdCode, item.employerName, item.employerNumber, item.employerPhone);
            //  } else {

            await this.Postentry_preRegister(res_userId, IdCode, item.employerName, item.employerNumber, item.employerPhone);

            await this.createImageAndSave(IdCode, item.Sex, item.Prefix, item.firstname, item.lastname, item.Nationality)

            //}
          } catch (error) {
            console.error("❌ Registration error:", error.response);
            // แสดงข้อความผิดพลาดใน Toast
            this.$toast({
              component: ToastificationContent,
              props: {
                title: error.response?.data?.message || "เกิดข้อผิดพลาด",
                icon: "EditIcon",
                variant: "danger",
              },
            });
          }
        });

        await Promise.all(promises);

        this.$toast({
          component: ToastificationContent,
          props: {
            title: "บันทึกข้อมูลสำเร็จทั้งหมด",
            icon: "CheckIcon",
            variant: "success",
          },
        });
      } catch (e) {
        console.log(e);
        console.error("❌ เกิดข้อผิดพลาดใหญ่", e);
      } finally {
        this.isLoading = false;
      }
    },
    async createImageAndSave(IdCode, gender, prefix, firstname, lastname, nationality) {
      // ขนาดบัตร NFC แนวตั้ง (scale 4px/mm)
      const canvas = document.createElement("canvas");
      canvas.width = 216;  // กว้าง
      canvas.height = 342; // สูง
      const ctx = canvas.getContext("2d");

      // พื้นหลังขาว
      ctx.fillStyle = "#fff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      // เส้นขอบ
      ctx.strokeStyle = "#000";
      ctx.lineWidth = 2;
      ctx.strokeRect(0, 0, canvas.width, canvas.height);

      // ข้อความ
      // ข้อความ
      ctx.fillStyle = "#000";
      ctx.font = "12px Arial";
      ctx.textAlign = "center";   // จัดกึ่งกลางแนวนอน
      ctx.textBaseline = "top";   // ใช้ top เพื่อเลื่อนแต่ละบรรทัดได้ง่าย

      let centerX = canvas.width / 2;
      ctx.fillText(`${prefix} ${firstname} ${lastname}`, centerX, 30);
      ctx.fillText(`ID: ${IdCode}`, centerX, 50);
      ctx.fillText(`Sex: ${gender}`, centerX, 70);
      ctx.fillText(`Nationality: ${nationality}`, centerX, 90);
      // ctx.fillStyle = "#000";
      // ctx.font = "12px Arial";
      // ctx.fillText(`${item.prefix} ${item.firstname} ${item.lastname}`, 10, 30);
      // ctx.fillText(`ID: ${item.IdCode}`, 10, 50);
      // ctx.fillText(`Sex: ${item.gender}`, 10, 70);
      // ctx.fillText(`Nationality: ${item.Nationality}`, 10, 90);
      // ฟังก์ชันสร้าง QR
      function getQrImage(url) {
        return new Promise((resolve, reject) => {
          QRCode.toDataURL(url, function (err, qrUrl) {
            if (err) reject(err);
            else {
              const img = new Image();
              img.onload = () => resolve(img);
              img.onerror = reject;
              img.src = qrUrl;
            }
          });
        });
      }


      try {
        const today = new Date();
        const day = String(today.getDate()).padStart(2, '0');
        const month = String(today.getMonth() + 1).padStart(2, '0'); // เดือนเริ่มจาก 0
        const year = today.getFullYear();

        //const dateObj = this.out_dateDefault; // Date object
        // const year_qr = dateObj.getFullYear();
        //  const month_qr = String(dateObj.getMonth() + 1).padStart(2, '0'); // เดือนเริ่มจาก 0
        // const day_qr = String(dateObj.getDate()).padStart(2, '0');



        const { VUE_APP_FONTEND_URL } = process.env;
        const qrUrl = `${VUE_APP_FONTEND_URL}booking?prm1=${IdCode}&prm2=${year + month + day}`;
        const img = await getQrImage(qrUrl);

        // วาง QR ด้านล่างตรงกลาง
        const qrSize = 200;
        const qrX = (canvas.width - qrSize) / 2;
        const qrY = canvas.height - qrSize - 20;
        ctx.drawImage(img, qrX, qrY, qrSize, qrSize);

        // เซฟไฟล์
        const link = document.createElement("a");
        link.href = canvas.toDataURL("image/png");
        link.download = `QR_${IdCode}.png`;
        link.click();

        this.$toast({
          component: ToastificationContent,
          props: {
            title: "ดาวน์โหลด QR Code สำเร็จ",
            icon: "CheckIcon",
            variant: "success",
          },
        });
        //  const today = new Date();
        //const day = String(today.getDate()).padStart(2, '0');
        // const month = String(today.getMonth() + 1).padStart(2, '0'); // เดือนเริ่มจาก 0
        // const year = today.getFullYear();

        await this.handleOutDateChange('', `${day}-${month}-${year}`);
        // await this.resetForm();

      } catch (error) {
        console.error("Error creating QR Code image:", error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "ดาวน์โหลดไม่สำเร็จ",
            icon: "EditIcon",
            variant: "danger",
          },
        });
      }
    },
  },
};
</script>